import { FC } from "react";
import { useModal } from "@refinedev/antd";
import { useDelete } from "@refinedev/core";
import { errorNotification, successNotification } from "../../../helpers";
import { Button, Modal } from "antd";

type VideoDeleteProps = {
  id: number;
  name: string;
};

export const VideoDelete: FC<VideoDeleteProps> = ({ id, name }) => {
  const { modalProps, show, close } = useModal();
  const { mutate } = useDelete();

  const handleDelete = () => {
    mutate({
      dataProviderName: "videoDataProvider",
      resource: "video",
      id,
      ...successNotification({
        successData: { message: `Видео «${name}» удалено`, type: "success" },
        callback: () => close(),
      }),
      ...errorNotification({}),
    });
  };

  return (
    <>
      <Button danger onClick={show} size="small">
        Удалить
      </Button>
      <Modal
        okText="Удалить"
        cancelText="Отмена"
        onOk={handleDelete}
        title="Подтверждение"
        onCancel={close}
        {...modalProps}
      >
        Вы уверены что хотите удалить видео «{name}»?
      </Modal>
    </>
  );
};
